/* eslint-disable @typescript-eslint/no-unused-vars */import { useContext, useEffect, useState } from 'react';
import { Holder, Subscription } from '../adapters/api-client/subscription/Subscription.model';
import { store } from '../store/store';
import { BirthInfoModel, ContactInfoModel, IdentityInfoModel, NationalityInfoModel } from '../store/store.model';
import { Step, StepModel, steps, stepsLocataire } from '../utils/Steps';
import { StepEvent, transition, transitionLocataire } from '../utils/StepStateMachine';
import { removeWhitespace } from '../utils/StringFormatter';

const stepByName = (name: Step): StepModel => {
  return steps.find((step) => step.name === name) ?? ({} as StepModel);
};
const stepByNameLocataire = (name: Step): StepModel => {
  return stepsLocataire.find((step) => step.name === name) ?? ({} as StepModel);
};
const getBackStepPath = (stepData: StepModel): string => {
  const backStep: Step = transition(stepData.name, StepEvent.BACK);
  return stepByName(backStep)?.path ?? stepData.path;
};
const getNextStepPath = (stepData: StepModel): string => {
  const nextStep: Step = transition(stepData.name, StepEvent.NEXT);
  return stepByName(nextStep)?.path ?? stepData.path;
};
const getBackStepPathLocataire = (stepData: StepModel): string => {
  const backStep: Step = transitionLocataire(stepData.name, StepEvent.BACK);
  return stepByNameLocataire(backStep)?.path ?? stepData.path;
};
const getNextStepPathLocataire = (stepData: StepModel): string => {
  const nextStep: Step = transitionLocataire(stepData.name, StepEvent.NEXT);
  return stepByNameLocataire(nextStep)?.path ?? stepData.path;
};
// const mapStoreToBackModel: (store: Partial<AppStoreModel>, currentStep: Step) => Partial<Subscription> = (
//   { holder, budget, familySituation, housing },
//   currentStep,
// ) => {
//   let backModel: Partial<Subscription> = { step: currentStep };
//   switch (currentStep) {
//     case Step.LOGEMENT:
//       backModel = { ...backModel, housing: housing ? fromLogementInfoToBack(housing) : {} };
//       break;
//     // case Step.CREDITS:
//     // backModel = { ...backModel, housing: housing ? fromLogementInfoToBack(housing) : {} };
//     // break;
//     case Step.IDENTITE:
//       backModel = {
//         ...backModel,
//         holder: holder?.identity ? fromIdentityInfoToBack(holder?.identity) : {},
//       };
//       break;
//     case Step.CONTACT:
//       backModel = { ...backModel, holder: holder?.contact ? fromContactInfoToBack(holder?.contact) : {} };
//       break;
//     // case Step.NATIONALITE:
//     //   backModel = {
//     //     ...backModel,
//     //     holder: holder?.nationalityInfo ? fromNationalityInfoToBack(holder?.nationalityInfo) : {},
//     //   };
//     //   break;
//     case Step.NAISSANCE:
//       backModel = { ...backModel, holder: holder?.identity ? fromBirthInfoToBack(holder?.identity) : {} };
//       break;
//     // case Step.ADRESSE:
//     //   backModel = { ...backModel, holder: holder?.addressInfo ? fromAddressInfoToBack(holder?.addressInfo) : {} };
//     //   break;
//     case Step.SITUATIONFAMILIALE:
//       backModel = {
//         ...backModel,
//         familySituation: familySituation ? fromSituationFamilialeInfoToBack(familySituation) : {},
//       };
//       break;
//     case Step.SITUATIONPRO:
//       backModel = {
//         ...backModel,
//         holder: holder?.job ? fromsituationProInfoToBack(holder?.job) : {},
//       };
//       break;
//     case Step.REVENUS:
//       backModel = {
//         ...backModel,
//         budget: budget?.income ? fromRevenusInfoToBack(budget?.income) : {},
//       };
//       break;
//     case Step.DEPENSES:
//       backModel = {
//         ...backModel,
//         budget: budget?.expenses ? fromDepensesInfoToBack(budget?.expenses) : {},
//         acceptTermContract: budget?.expenses
//           ? fromDepensesInfoToAcceptTermContract(budget?.expenses.acceptTermContract)
//           : false,
//       };
//       break;
//   }
//   return backModel;
// };

const fromIdentityInfoToBack: (identityInfo: IdentityInfoModel) => Holder = ({
  civility,
  lastname,
  firstname,
  birthName,
}: IdentityInfoModel) => {
  return {
    identity: {
      civility,
      lastname,
      firstname,
      birthName: birthName == undefined || birthName == '' ? undefined : birthName,
    },
  };
};

// const fromIdentityInfoToFamilySituationBack: (
//   familySituation: FamilySituationInfoModel,
// ) => FamilySituation = ({ maritalStatusCode }: FamilySituationInfoModel) => {
//   return {
//     maritalStatusCode,
//   };
// };

const fromContactInfoToBack: (contact: ContactInfoModel) => Holder = ({
  addressMail,
  mobilePhone,
  homePhone,
  employmentPhone,
}: ContactInfoModel) => {
  return {
    contact: {
      addressMail,
      mobilePhone: removeWhitespace(mobilePhone),
      homePhone: homePhone == undefined || homePhone == '' ? undefined : removeWhitespace(homePhone),
      employmentPhone:
        employmentPhone == undefined || employmentPhone == '' ? undefined : removeWhitespace(employmentPhone),
    },
  };
};

const fromNationalityInfoToBack: (nationalityInfo: NationalityInfoModel) => Holder = ({
  birthCountry,
  nationality,
}: NationalityInfoModel) => {
  return {
    identity: {
      nationalityCountryCode: nationality ? nationality.countryCode : '',
      birthCountryCode: birthCountry ? birthCountry.countryCode : '',
    },
  };
};

const fromBirthInfoToBack: (birthInfo: BirthInfoModel) => Holder = ({
  birthDate,
  birthDepartment,
}: // birthCity,
BirthInfoModel) => {
  return {
    identity: {
      birthDate: birthDate ? birthDate : '',
      birthDepartmentCode: birthDepartment ? (birthDepartment.code === '' ? '99' : birthDepartment.code) : '',
      // birthCityName: birthCity ? birthCity.name : '',
      // birthCityInseeNumber: birthCity && birthCity.inseeNumber !== '' ? birthCity.inseeNumber : undefined,
    },
  };
};

// const fromAddressInfoToBack: (addressInfo: AddressInfoModel) => Holder = ({
//   address,
//   addressBis,
//   zipCode,
//   addressCity,
// }: AddressInfoModel) => {
//   return {
//     contact: {
//       streetAddress: address ? address : '',
//       additionalAddress: addressBis ? addressBis : undefined,
//       zipCode: zipCode ? zipCode : '',
//       cityAddress: addressCity ? addressCity.name : '',
//     },
//   };
// };

// const fromLogementInfoToBack: (housing: HousingInfoModel) => Housing = ({
//   housingCode,
//   housingData,
// }: HousingInfoModel) => {
//   return {
//     housingCode: housingCode ? housingCode : '',
//     housingData: housingData ? housingData : '',
//   };
// };

// const fromSituationFamilialeInfoToBack: (familySituation: FamilySituationInfoModel) => FamilySituation = ({
//   childrenCount,
//   maritalStatusCode,
// }: FamilySituationInfoModel) => {
//   return {
//     childrenCount,
//     maritalStatusCode,
//   };
// };

// const fromsituationProInfoToBack: (job: JobInfoModel) => Holder = ({
//   activitySectorCode,
//   profession,
//   beginningEmploymentDate,
//   employmentContractCode,
// }: JobInfoModel) => {
//   return {
//     job: {
//       activitySectorCode: activitySectorCode ? activitySectorCode.code : '',
//       cspCode: profession ? profession.code : '',
//       beginningEmploymentDate: beginningEmploymentDate ? addDayToDate(beginningEmploymentDate) : '',
//       employmentContractCode:
//         employmentContractCode && employmentContractCode.code ? employmentContractCode.code : undefined,
//     },
//   };
// };

// const fromRevenusInfoToBack: (income: IncomeInfoModel) => Budget = ({
//   holderSalaryAmount,
//   monthlyPaymentCount,
// }: IncomeInfoModel) => {
//   return {
//     income: {
//       holderSalaryAmount: +removeWhitespace(holderSalaryAmount),
//       monthlyPaymentCount,
//     },
//   };
// };

// const fromRevenusSuiteInfoToBack: (income: IncomeInfoModel) => Budget = ({
//   familyAllowance,
//   otherIncome,
//   pensionIncome,
//   propertyIncome,
// }: IncomeInfoModel) => {
//   return {
//     income: {
//       familyAllowance: +removeWhitespace(familyAllowance),
//       otherIncome: +removeWhitespace(otherIncome),
//       pensionIncome: +removeWhitespace(pensionIncome),
//       propertyIncome: +removeWhitespace(propertyIncome),
//     },
//   };
// };

// const fromDepensesInfoToBack: (expenses: ExpensesInfoModel) => Budget = ({ rentAmount }: ExpensesInfoModel) => {
//   return {
//     expenses: {
//       rentAmount: +removeWhitespace(rentAmount),
//     },
//   };
// };

const fromDepensesInfoToAcceptTermContract = (acceptTermContract: boolean) => {
  return acceptTermContract === undefined ? false : acceptTermContract;
};

export const useStep = (
  currentStep: Step,
): {
  stepData: StepModel;
  nextStep: string;
  backStep: string;
  stepBackModel: Partial<Subscription>;
} => {
  const [nextStep, setNextStep] = useState<string>('');
  const [backStep, setBackStep] = useState<string>('');
  const [stepData, setStepData] = useState<StepModel>(stepByName(currentStep));
  const [stepBackModel, setStepBackModel] = useState<Partial<Subscription>>({} as Partial<Subscription>);
  const {
    state: { housing },
  } = useContext(store);

  useEffect(() => {
    const stepInfo = stepByName(currentStep);
    const stepInfoLocataire = stepByNameLocataire(currentStep);
    if (housing?.housingCode !== 'L') {
      setNextStep(getNextStepPath(stepInfo));
      setBackStep(getBackStepPath(stepInfo));
      setStepData(stepInfo);
    } else {
      setNextStep(getNextStepPathLocataire(stepInfoLocataire));
      setBackStep(getBackStepPathLocataire(stepInfoLocataire));
      setStepData(stepInfoLocataire);
    }
  }, [currentStep]);

  // useEffect(() => {
  //   if (store) {
  //     setStepBackModel(mapStoreToBackModel(store, currentStep));
  //   }
  // }, [store, currentStep]);

  return { stepData, nextStep, backStep, stepBackModel };
};
